import apiWrapper from '../../services/apiWrapper';

const getChurchData = async (token) => {
  try {
    console.log(token);
    const response = await apiWrapper('get', `/get-church-data?token=${token}`);

    return response;
  } catch (error) {
    console.error('Get church data error:', error.message);
    return {
      success: false,
      tokenStatus: 'invalid',
      churchData: null
    };
  }
};

export default getChurchData;
